import React from 'react'
import './about-content.scss'
import AboutEvent from '../../molecules/about-event/aboutEvent'
import GuideTo from '../../molecules/guided-to/guideTo'

const aboutContent = props => {
  const { data, isSecondStyle = false } = props;
  return (
    <div className="m-about-content" id="evento">
      <AboutEvent aboutInfo={data.sobreElEvento} />
      <GuideTo isSecondStyle={isSecondStyle} guideInfo={data.dirigidoA} />
    </div>
  )
}

export default aboutContent
